module.exports = __webpack_public_path__ + "media/images/flags/dz-b139b8d0a6aceb4b89bd27e86fc0baee.svg";